import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import Stats from '@/views/stats'
import PlateEditorRegion from '@/views/plate_editor/region'
import PlateEditorRoads from '@/views/plate_editor/roads'
import MetroEditor from '@/views/metro_editor'
import PlanarGraphEditor from '@/views/planar_graph_editor'
import cookie from '@/common/cookie'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Stats,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/stats',
      name: 'Stats',
      component: Stats,
    },
    {
      path: '/:city?/plate_editor/plates/:plate_id/plate_facilities/:plate_facility_id',
      name: 'PlateEditorRoads',
      component: PlateEditorRoads
    },
    {
      path: '/:city?/plate_editor/plates/:plate_id',
      name: 'PlateEditorRegion',
      component: PlateEditorRegion
    },
    {
      path: '/:city?/metro_editor/:id',
      name: 'MetroEditor',
      component: MetroEditor
    },
    {
      path: '/:city/planar_graph_editor/:id',
      name: 'PlanarGraphEditor',
      component: PlanarGraphEditor
    }
  ],
})

const whitePages = ['Login', 'PlateEditorRoads', 'PlateEditorRegion', 'MetroEditor', 'PlanarGraphEditor']

router.beforeEach((to, from, next) => {
  const token = cookie.getItem('cdfang_token')
  if (whitePages.indexOf(to.name) === -1 && !token) {
    console.log('______login______')
    next('/login')
  } else {
    next()
  }
})

export default router
